<!--
  Copyright 2026 Tecnalia, Basque Research & Technology Alliance (BRTA)

  Licensed under the Apache License, Version 2.0 (the "License");
  you may not use this file except in compliance with the License.
  You may obtain a copy of the License at
 
     http://www.apache.org/licenses/LICENSE-2.0
 
  Unless required by applicable law or agreed to in writing, software
  distributed under the License is distributed on an "AS IS" BASIS,
  WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
  See the License for the specific language governing permissions and
  limitations under the License.
 
   SPDX-License-Identifier: Apache-2.0
-->

<main class="auth-feedback-page">
	<section class="auth-feedback-card" aria-labelledby="login-error-title">
		<div class="auth-feedback-brand">
			<img src="assets/images/Tecnalia_Logo.jpg" draggable="false" [attr.alt]="'AUTH_FEEDBACK.LOGO_ALT' | translate">
			<div class="auth-feedback-brand__content">
				<span class="auth-feedback-kicker">{{ 'AUTH_FEEDBACK.PRODUCT' | translate }}</span>
				<span class="auth-feedback-brand__title">{{ 'AUTH_FEEDBACK.BRAND_TITLE' | translate }}</span>
			</div>
		</div>

		<div class="auth-feedback-content">
			<div class="auth-feedback-icon" aria-hidden="true">
				<svg viewBox="0 0 24 24" focusable="false">
					<path d="M12 8v5"></path>
					<path d="M12 17h.01"></path>
					<path d="M10.3 3.9 2.6 17.2A2 2 0 0 0 4.3 20h15.4a2 2 0 0 0 1.7-2.8L13.7 3.9a2 2 0 0 0-3.4 0Z"></path>
				</svg>
			</div>

			<span class="auth-feedback-kicker">{{ 'LOGIN_ERROR.TITLE' | translate }}</span>
			<h1 id="login-error-title" class="auth-feedback-title">
				{{ 'LOGIN_ERROR.MSG_1' | translate }}
			</h1>
			<p class="auth-feedback-message">
				{{ 'LOGIN_ERROR.MSG_2' | translate }}
			</p>

			<button type="button" class="btn auth-feedback-button" (click)="login()">
				{{ 'LOGIN_ERROR.LOGIN_BUTTON' | translate }}
			</button>
		</div>
	</section>

	<footer class="auth-feedback-footer">
		{{ 'AUTH_FEEDBACK.FOOTER' | translate }}
	</footer>
</main>